import { GridColDef } from "@mui/x-data-grid";
import { t } from "i18next";
import DataGridApi from "../../../../components/dataGridApi";
import { ISpreadsheet } from "../../../../interfaces/ISpreadsheet";
import { CONFIG } from "../../../../services/config";

interface Props {
  spreadsheet?: ISpreadsheet;
}

export default function AmarokComLimiteKm({ spreadsheet }: Props) {
  const columns: GridColDef[] = [
    {
      field: "vin",
      flex: 1,
      headerName: t("digitalServicePlan.vin"),
      headerClassName: "header-style",
    },
    {
      field: "limitOdometer",
      flex: 1,
      headerName: t("digitalServicePlan.limitOdometer"),
      headerClassName: "header-style",
    },
    {
      field: "limitMonth",
      flex: 1,
      headerName: t("digitalServicePlan.limitMonthAmarok"),
      headerClassName: "header-style",
    },
  ];
  return (
    <DataGridApi
      params1="&param="
      labelParams1="Chassi"
      host={CONFIG.SOB_API}
      endPoint={`excel/warranty/${spreadsheet?.id}?`}
      columnsData={columns}
    />
  );
}
